[
  {
    "id": "SWW-M6P-L104-001",
    "module": "SpellingWW",
    "difficulty": 104,
    "difficultyTier": 4,
    "levelCode": "M6+",
    "group": 6,
    "question": "Gisteren ... wij naar het strand. (gaan)",
    "options": ["gingen", "gaat", "ging", "gegaan"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verleden_tijd",
    "subSkill": "vt_onregelmatig_meervoud",
    "familyId": "SWW-VT-ONREGELMATIG-GAAN",
    "conceptId": "past_tense_irregular_gaan_plural",
    "variantIndex": 1,
    "explanation": "Door 'gisteren' kies je verleden tijd.\nOnderwerp is 'wij', dus meervoud.\nVan 'gaan' is de verleden tijd meervoud: gingen.",
    "distractorExplanations": {
      "1": "Dit is tegenwoordige tijd. 'Gisteren' vraagt om verleden tijd.",
      "2": "Dit is verleden tijd enkelvoud (hij ging). Maar het onderwerp is meervoud: wij gingen.",
      "3": "Dit is het voltooid deelwoord. Dat gebruik je met 'zijn': wij zijn gegaan."
    }
  },
  {
    "id": "SWW-M6P-L104-002",
    "module": "SpellingWW",
    "difficulty": 104,
    "difficultyTier": 4,
    "levelCode": "M6+",
    "group": 6,
    "question": "Hij ... gisteren een tekening. (kleuren)",
    "options": ["kleurde", "kleurte", "kleurt", "gekleurd"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verleden_tijd",
    "subSkill": "vt_zwak_te_de",
    "familyId": "SWW-VT-ZWAK-TEDE-TKOF",
    "conceptId": "past_tense_weak_verb_de_rule",
    "variantIndex": 1,
    "explanation": "Door 'gisteren' kies je verleden tijd.\nStam van 'kleuren' is 'kleur'.\nDe laatste letter r zit niet in 't kofschip, dus je kiest 'de': kleurde.",
    "distractorExplanations": {
      "1": "Je kiest 'te', maar r zit niet in 't kofschip. Daarom wordt het kleurde.",
      "2": "Dit is tegenwoordige tijd. Door 'gisteren' moet het verleden tijd zijn.",
      "3": "Dit is het voltooid deelwoord. Dat gebruik je met 'heeft': hij heeft gekleurd."
    }
  },
  {
    "id": "SWW-M6P-L104-003",
    "module": "SpellingWW",
    "difficulty": 104,
    "difficultyTier": 4,
    "levelCode": "M6+",
    "group": 6,
    "question": "De jongen heeft ... (krabben).",
    "options": ["gekrabd", "gekrabt", "krabde", "krabt"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "voltooid_deelwoord",
    "subSkill": "vd_zwak_d_of_t",
    "familyId": "SWW-VD-ZWAK-DT-KEUZE",
    "conceptId": "past_participle_weak_d_rule",
    "variantIndex": 1,
    "explanation": "Na 'heeft' komt een voltooid deelwoord.\nHele werkwoord: krabben. Stam: krab.\nDe b zit niet in 't kofschip, dus het voltooid deelwoord eindigt op d: gekrabd.",
    "distractorExplanations": {
      "1": "Je kiest t, maar b zit niet in 't kofschip. Daarom moet het d zijn: gekrabd.",
      "2": "Dit is verleden tijd. Na 'heeft' hoort een voltooid deelwoord.",
      "3": "Dit is tegenwoordige tijd. Na 'heeft' hoort een voltooid deelwoord."
    }
  },
  {
    "id": "SWW-M6P-L104-004",
    "module": "SpellingWW",
    "difficulty": 104,
    "difficultyTier": 4,
    "levelCode": "M6+",
    "group": 6,
    "question": "De ... appel was lekker. (schillen)",
    "options": ["geschilde", "geschilt", "schilde", "geschild"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "bijvoeglijk_deelwoord",
    "subSkill": "bnvd_enkelvoud_de",
    "familyId": "SWW-BNVD-E-ENKELVOUD-DE",
    "conceptId": "bnvd_singular_de_noun",
    "variantIndex": 1,
    "explanation": "Je beschrijft de appel, dus je gebruikt het bijvoeglijk gebruikte voltooid deelwoord.\nHet voltooid deelwoord van 'schillen' is 'geschild'.\nBij 'de appel' komt er een -e achter: geschilde.",
    "distractorExplanations": {
      "1": "Dit is het voltooid deelwoord zonder -e. In deze zin beschrijf je de appel, dus je gebruikt geschilde.",
      "2": "Dit is verleden tijd. De zin vraagt om een beschrijving, niet om een persoonsvorm.",
      "3": "Dit mist de juiste uitgang. Het voltooid deelwoord is geschild, en bijvoeglijk wordt dat geschilde."
    }
  },
  {
    "id": "SWW-M6P-L104-005",
    "module": "SpellingWW",
    "difficulty": 104,
    "difficultyTier": 4,
    "levelCode": "M6+",
    "group": 6,
    "question": "Het boek is ... (vallen).",
    "options": ["gevallen", "gevald", "viel", "valt"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "voltooid_deelwoord",
    "subSkill": "vd_sterk",
    "familyId": "SWW-VD-STERK-BASIS",
    "conceptId": "past_participle_strong_basic",
    "variantIndex": 2,
    "explanation": "Na 'is' gebruik je een voltooid deelwoord.\n'Vallen' is een sterk werkwoord.\nHet voltooid deelwoord is: gevallen.",
    "distractorExplanations": {
      "1": "Dit bestaat niet als juiste spelling. Je kunt bij sterke werkwoorden geen d of t toevoegen volgens 't kofschip.",
      "2": "Dit is verleden tijd. Na 'is' hoort het voltooid deelwoord.",
      "3": "Dit is tegenwoordige tijd. Na 'is' hoort het voltooid deelwoord."
    }
  }
]
